export default (title, note = null, button = null, solution = null) => ({
  title,
  note,
  button,
  solution,
});



// WEBPACK FOOTER //
// ../../src/messages/composeMessage.js